import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL, PHONE_DISPLAY, EMAIL, EMAIL_MAILTO, SEO_LINKS } from "../data/content";

export const Footer = () => (
  <footer className="pt-24 pb-32 border-t border-[#E3DCCB]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <h2 className="font-serif-display text-3xl sm:text-5xl font-semibold text-stone-800 leading-tight max-w-3xl">
        Your next breath deserves <span className="text-teal-700 italic">the best hands.</span>
      </h2>
      <p className="mt-5 text-base text-stone-500 max-w-xl leading-relaxed">
        Interventional Pulmonology, Critical Care & Sleep Medicine — consult Dr. Siddarth Singh
        (MBBS, MD, DM, AIIMS Bhubaneswar) at Amcare Hospital, Zirakpur or IRCC Hospital, Panchkula.
      </p>
      <div className="mt-9 flex flex-wrap gap-4">
        <a href={PHONE_TEL} data-testid="footer-call-button"
          className="flex items-center gap-3 px-8 py-4 rounded-full bg-[#0B5A4E] text-[#FAF8F3] font-semibold text-sm hover:bg-[#0D6B5C] transition-colors">
          <Phone size={16} /> {PHONE_DISPLAY}
        </a>
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-button"
          className="flex items-center gap-3 px-8 py-4 rounded-full border border-[#25D366]/50 text-[#25D366] font-semibold text-sm hover:bg-[#25D366]/10 transition-colors">
          <MessageCircle size={16} /> WhatsApp for Appointment
        </a>
        <a href={EMAIL_MAILTO} data-testid="footer-email-button"
          className="flex items-center gap-3 px-8 py-4 rounded-full border border-[#E3DCCB] text-stone-600 font-semibold text-sm hover:border-teal-500/40 hover:text-teal-700 transition-colors">
          <Mail size={16} /> {EMAIL}
        </a>
      </div>
      <div className="mt-14 pt-8 border-t border-[#E3DCCB]/60" data-testid="footer-seo-links">
        <p className="font-mono-tag text-[10px] uppercase tracking-[0.25em] text-stone-400 mb-4">
          Consult Dr. Singh — Specialities & Locations
        </p>
        <div className="flex flex-wrap gap-x-6 gap-y-2.5">
          {SEO_LINKS.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`}
              className="text-xs text-stone-500 hover:text-teal-700 transition-colors">
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className="mt-10 pt-8 border-t border-[#E3DCCB]/60 flex flex-col sm:flex-row justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src="/assets/ircc-logo.png" alt="IRCC Group of Hospitals" className="w-8 h-8 object-contain rounded bg-white p-0.5 border border-[#E3DCCB]" data-testid="footer-logo" />
          <p className="font-mono-tag text-[10px] uppercase tracking-[0.25em] text-stone-400">
            © {new Date().getFullYear()} Dr. Siddarth Singh · Pulmonology · Critical Care · Sleep Medicine
          </p>
        </div>
        <p className="font-mono-tag text-[10px] uppercase tracking-[0.25em] text-stone-400">
          Zirakpur, Punjab · Panchkula, Haryana
        </p>
      </div>
    </div>
  </footer>
);
